import { get } from '../services/Generic.api';

export const fetchSources = async ( searchTerm = "") => {
    try {
      const response = await get(`/source/`, {
          name__icontains: searchTerm,
          is_active: true,
      });
      return response.results;
    } catch (error) {
      console.error('Erro ao buscar veículos:', error.response);
      throw error;
    }
  };
